var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.title_tag,{tag:"component",staticClass:"default-title",class:_vm.component_classes,domProps:{"innerHTML":_vm._s(_vm.title)}})
}
var staticRenderFns = []

export { render, staticRenderFns }